import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"

export const useGetCode = ({group_code }: { group_code: string }) => {
    const api = useApi()
    const [code, setCode] = useState<string>("")
    const [isLoading, setLoading] = useState(true)

    const fetchData = () => {
        api.post(`/assetdepre/generate_asset_code?group_code=${group_code}`)
        .then((res: SuccessFetch<{ payload: { next_code: string } }>) => {
            setCode(res.data.payload.next_code)
        })
        .catch(() => setCode(""))
        .finally(() => setLoading(false))
    }

    const refetch = () => fetchData()

    useEffect(() => {
        fetchData()

        return () => {
            setCode("")
            setLoading(true)
        }

        // eslint-disable-next-line
    }, [group_code])

    return { code, isLoading, refetch }
}


export const useGetCodePicture = () => {
    const api = useApi()
    const [code, setCode] = useState<string>("")
    const [isLoading, setLoading] = useState(true)

    const fetchData = () => {
        api.get(`/assetdepre/gen_asset_picture_code`)
        .then((res: SuccessFetch<{ payload: { assetpicturecode: string } }>) => {
            setCode(res.data.payload.assetpicturecode)
        })
        .catch(() => setCode(""))
        .finally(() => setLoading(false))
    }

    const refetch = () => fetchData()

    useEffect(() => {
        fetchData()

        return () => {
            setCode("")
            setLoading(true)
        }

        // eslint-disable-next-line
    }, [])

    return { code, isLoading, refetch }
}



